export const LOCAL_STORAGE_KEY = 'BB_POS';
